<template>
  <div class="hbb_ab">
    <el-carousel :interval="3000" arrow="always">
      <template v-if="list.length>0">
        <el-carousel-item v-for="(item,index) in list" :key="item">
          <div class="hbb_Img_box">
            <img :src="item" alt="暂无图片" @click.stop="onPreview(item,index)" />
          </div>
        </el-carousel-item>
      </template>
      <template v-else>
        <el-carousel-item>
          <div class="hbb_Img_box">
            <img src="@assets/images/wu.png" />
          </div>
        </el-carousel-item>
      </template>
    </el-carousel>
    <!-- 查看产品大图 -->
    <ZhipeiViewer v-if="showViewer" :on-close="closeViewer" :url-list="previewUrl" />
  </div>
</template>

<script>
import ZhipeiViewer from "../ZhipeiViewer/image-viewer";
export default {
  components: {
    ZhipeiViewer
  },
  props: {
    list: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      showViewer: false, // 查看大图组件是否启动
      previewUrl: [] // 要放大的图片地址
    };
  },
  methods: {
    onPreview(item,index) {
      // 点击查看产品大图 启动
      this.showViewer = true;
      let tempImgList = [...this.list];
      let temp = [];
      for (let i = 0; i < index; i++) {
        temp.push(tempImgList.shift());
      }
      this.previewUrl = tempImgList.concat(temp);
    },
    closeViewer() {
      // 点击查看产品大图 销毁
      this.showViewer = false;
    }
  }
};
</script>

<style scope>
.el-carousel__item h3 {
  color: #475669;
  font-size: 18px;
  opacity: 0.75;
  line-height: 300px;
  margin: 0;
}

.el-carousel__item {
  background: #fafafa;
  text-align: center;
}
.hbb_Img_box {
  width: 100%;
  height: 100%;
  position: relative;
}
.el-carousel__item img {
  width: auto;
  height: auto;
  max-width: 100%;
  max-height: 100%;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  margin: auto;
}
</style>